import { Link } from "react-router-dom";

/**
 * Footer Component
 * App footer for authenticated pages.
 * Displays copyright information and legal links.
 */
export function Footer() {
  return (
    <footer className="border-t border-border bg-background mt-auto">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm">
          {/* Copyright */}
          <p className="text-muted-foreground">
            &copy; 2026 DeTrust AI. All rights reserved.
          </p>

          {/* Legal Links */}
          <div className="flex items-center gap-4">
            <Link
              to="/legal/privacy"
              className="text-muted-foreground hover:text-foreground transition-colors underline-offset-4 hover:underline"
            >
              Privacy Policy
            </Link>
            <span className="text-border">|</span>
            <Link
              to="/legal/terms"
              className="text-muted-foreground hover:text-foreground transition-colors underline-offset-4 hover:underline"
            >
              Platform Terms &amp; Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
